// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=file][data-v-ba6bc394]{display:none}.sc-user-input--file-icon-wrapper[data-v-ba6bc394]{display:block;cursor:pointer}.sc-user-input--file-icon[data-v-ba6bc394]{display:block}", ""]);
// Exports
module.exports = exports;
